module.exports = __webpack_public_path__ + "img/GreenAltar.f3dafde9.png";